import { BmRUMConfiguration, initializeDatadog } from '@onviobr/datadog';

export const staffRumPiiScrubConfig = {
	// scrub these fields
	actionTargetName: true,
	viewReferrer: true,
	// don't scrub below fields
	errorMessage: false,
	errorResourceUrl: false,
	errorStack: false,
	resourceUrl: false,
	viewUrl: false,
};

export const staffRumConfig: BmRUMConfiguration = {
	applicationId: '2678c199-9934-4e6c-9d54-dcf3e885d06f',
	clientToken: 'pub344588f190223a9a67befd24d23aab70',
	useLoadTimeTracking: true,
	allowedTracingOrigins: [
		/https:\/\/(.+\.)?onvio\..*/,
		// Allow traces on locally served apps
		// Disallow 127.0.0.1 because interferes with DMS' desktop doc scan integration
		/https?:\/\/(localhost|0\.0\.0\.0).*/,
	],
	beforeSend: (event) => {
		const viewUrlArray = event.view.url.split('#');
		const newUrlRoutes = [];
		if (viewUrlArray.length > 1) {
			const viewUrlRoutes = viewUrlArray[1].split('/');
			for (const eachRoute of viewUrlRoutes) {
				if ((countInString(eachRoute.toLowerCase()).numberCount > 7)) {
					newUrlRoutes.push('?');
				} else {
					newUrlRoutes.push(eachRoute);
				}
			}
		}
		event.view.url = viewUrlArray[0].concat('#', newUrlRoutes.join('/'));
	}
};

function countInString(str) {
	let numberCount = 0;
	let alphabetCount = 0;
	for (const character of str) {
		if (isAlphabet(character)) {
			alphabetCount++;
		} else if (isNumber(character)) {
			numberCount++;
		}
	}
	return { numberCount, alphabetCount };
}

function isAlphabet(str) {
	if (
		(str.charCodeAt(0) >= 65 && str.charCodeAt(0) <= 90)
	) {
		return true;
	}
}

function isNumber(str) {
	return !isNaN(parseInt(str, 10));
}


export function initializeDatadogStaffApp() {
	initializeDatadog(staffRumConfig);
}
